document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.querySelector(".js-custom-mega-open");
  const overlay = document.getElementById("CustomMegaOverlay");
  if (!openBtn || !overlay) return;

  const categories = overlay.querySelectorAll(".custom-mega-category");
  const panels = overlay.querySelectorAll(".custom-mega-products");

  openBtn.addEventListener("click", () => {

  const closeBtn = overlay.querySelector(".js-custom-mega-close");

  const closeOverlay = () => {
    overlay.classList.remove("is-active");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  if (closeBtn) closeBtn.addEventListener("click", closeOverlay);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-active")) closeOverlay();
  });

    overlay.classList.add("is-active");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    // Activate first category by default
    const firstCategory = categories[0];
    if (firstCategory) {
      firstCategory.dispatchEvent(new Event("mouseenter"));
    }
  });

  categories.forEach(cat => {
  cat.addEventListener("mouseenter", () => {
    const handle = cat.dataset.handle;

    categories.forEach(c => c.classList.remove("is-active"));
    cat.classList.add("is-active");

    panels.forEach(panel => {
      panel.classList.toggle(
        "is-active",
        panel.dataset.panel === handle
      );
    });
  });
});

});
